export default {
	baseTop: $(document).scrollTop(),
	baseTimer: 10000,

	init() {
		$('.popup-auto #close_auto').on('click', () => {
			$('.popup-auto').css('display', 'none');
			$('.popup-auto').removeClass('popup-auto-open');

			this.setCookie('rdbx-webinar_popup', 'true', 7); //create cookie
		});

		$('.popup-auto .btn').on('click', (event) => {
			event.preventDefault();

			$('.popup-auto').css('display', 'none');
			$('.popup-auto').removeClass('popup-auto-open');

			this.setCookie('rdbx-webinar_popup', 'true', 7); //create cookie

			window.open($(event.currentTarget).attr('href'), '_blank');
		});

		$(window).on(
			'scroll.onscroll',
			this.appendPopupOnScroll.bind(this, [this.baseTop])
		);

		this.timeout = setTimeout(() => {
			this.appendPopup();
		}, this.baseTimer);

		document.addEventListener('fullscreenchange', () => {
			if (document.fullscreenElement) {
				clearTimeout(this.timeout);
			} else {
				this.timeout = setTimeout(() => {
					this.appendPopup();
				}, this.baseTimer);
			}
		});
	},

	setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		var expires = 'expires=' + d.toUTCString();
		document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
	},

	appendPopupOnScroll(baseTop) {
		const newTop = $(document).scrollTop();
		if (Math.abs(baseTop - newTop) > 4000) {
			this.appendPopup();
		}
	},

	appendPopup() {
		$('.popup-auto').fadeIn(500);
		$('.popup-auto').addClass('popup-auto-open');

		clearTimeout(this.timeout);
		$(window).off('.onscroll');
	},
};
